import type { PromoCodesPageStore } from '@ctct/state-client-layer';

import type { PromoCodesService } from './PromoCodesService';
import type { TEventSource } from '../../../helpers';
import type { TranslationGetter } from '../../../types';
import { isCodeValidForPeriod } from '../helpers';

export class PeriodBasedPromoCodeService {
  constructor(
    private pageStore: PromoCodesPageStore,
    private promoCodesService: PromoCodesService,
    private t: TranslationGetter,
    paymentPeriod: string | null
  ) {
    if (paymentPeriod) {
      this.onPaymentPeriodChange(paymentPeriod, 'api');
    }
  }

  public api() {
    return {};
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }

  private onPaymentPeriodChange(period: string, source: TEventSource) {
    this.removePromoCodesNotValidForPeriod(period, source);
    this.removePeriodRelatedPromoCodeError(period);
  }

  public setPeriodRelatedPromoCodeError(validPeriodForCode: string) {
    this.promoCodesService.setErrors([
      this.t('application-layer.promo-codes.add.error-promo-on-prepay-only', { period: validPeriodForCode }),
    ]);
  }

  private removePromoCodesNotValidForPeriod(newPeriod: string, source: TEventSource) {
    this.promoCodesService
      .api()
      .getValidatedPromoCodes()
      .forEach((entry) => {
        if (!isCodeValidForPeriod(entry, newPeriod)) {
          this.promoCodesService.removePromoCode(entry, source);
        }
      });
  }

  private removePeriodRelatedPromoCodeError(newPeriod: string) {
    const { promoCodeTextFieldValue: promoCode, promoCodeFormErrors } = this.pageStore.getState();

    if (!isCodeValidForPeriod(promoCode, newPeriod)) {
      return;
    }

    const errorToBeRemoved = this.t('application-layer.promo-codes.add.error-promo-on-prepay-only', {
      period: newPeriod,
    });
    const updatedErrors = promoCodeFormErrors.filter((error) => error !== errorToBeRemoved);

    this.pageStore.setState({ promoCodeFormErrors: updatedErrors });
  }
}
